export const entryPhotoStrings = {
  photos: 'Photos',
  addPhotos: 'Add photos',
  cover: 'Cover',
  setAsCover: 'Set as cover',
  removeCover: 'Remove cover',
  removeCoverPrompt: 'Remove cover photo?',
  storageNearlyFull: 'Photo storage is almost full.',
  storageFull: 'Photo storage is full. Remove a photo or change your plan.',
  photoCount: (count) => `${count} of 5 photos`,
  maxPhotosError: 'Choose up to 5 photos.',
  coverPhoto: 'Cover photo',
  addCoverPhoto: 'Add cover photo',
  replaceCoverPhoto: 'Replace cover photo',
  highlights: 'Additional photos',
  addHighlight: 'Add photo',
  removeHighlight: 'Remove photo',
  shareHighlights: 'Share new highlights with trip guests',
  albums: 'Photo albums',
  addAlbumLink: 'Add album link',
  emptyAlbums: 'Keep your photos in your favorite album service and link them here.',
  albumName: 'Album name',
  albumLink: 'Album link',
  invalidAlbumLink: 'Add an album name and a secure https:// link.',
  tripSavedWithoutAlbum: 'Trip saved, but the album link was not added. Add it from Edit.',
  hikeSavedWithoutAlbum: 'Hike saved, but the album link was not added. Add it from Edit.',
  tripSavedWithoutPhoto: 'Trip saved, but one photo could not be added. Add it from Edit.',
  hikeSavedWithoutPhoto: 'Hike saved, but one photo could not be added. Add it from Edit.',
  retryPhotos: 'Retry photos',
  sharedAlbum: 'Visible to people this trip is shared with',
  albumStorageNote: 'Hobtalk stores the link, not the photos in this album.',
  addAlbum: 'Add album',
  editAlbum: 'Edit album',
  removeAlbum: 'Remove link',
  saveAlbum: 'Save album',
  removeAlbumPrompt: (label) => `Remove ${label}? This will not delete photos from the album provider.`,
  removePhotoPrompt: 'Remove highlight photo?',
  storage: (used, limit) => `Photo storage: ${used} of ${limit} MB`,
};
